import type { AsyncBelongsTo } from '@ember-data/model';
import BaseItemModel from './base-item';
import type TeamModel from './team';

export default class TeamBasedModel extends BaseItemModel {
  // Each subclass declares the relationship itself.
  declare team: AsyncBelongsTo<TeamModel>;

  get parent() {
    return this.team;
  }

  get parentType() {
    return 'team';
  }
}
